import React from 'react'
import PropTypes from 'prop-types'
import { 
    SubServicesMain,
    SubServicesTitle
} from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import Grid from '@components/Grid'
import GridItem from '@components/GridItem'
import { colors } from '@styles/vars/colors.style'
import SubSeviceItem from './subServiceItem'

const SubServices = ({subServices , backgroundColor, textColor}) => {

  const background = backgroundColor ? backgroundColor : colors.white;
  const color = textColor ? textColor : colors.charcoal;

  
  return (
    <SubServicesMain color={color} background={background}>
        <Spacer size={[40, 100]} />
        <Container>
            <Grid>
                <GridItem tabletL={6}>
                    <SubServicesTitle>Experts in</SubServicesTitle>
                    <Spacer size={[20, 120]} />
                </GridItem>
                <GridItem tabletL={8}>
                    <Spacer size={[20, 60]} />
                    {subServices.map((item, index) => (
                        <SubSeviceItem item={item} key={index} />
                    ))}
                </GridItem>
            </Grid>
        </Container>
        <Spacer size={[40, 200]} />
    </SubServicesMain>
  )
}

SubServices.propTypes = {
  expertItems: PropTypes.array,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string
}

export default SubServices
